import * as React from "react";
import { render } from "react-dom";
import { Main } from "./main/main";
const $root = document.getElementById("root");
render(React.createElement(Main, null), $root);
